import React, { useState, useMemo, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
} from "@mui/material";
import _ from "lodash";
import { locationsSelector } from "../../../store/slices/location";
import { useSelector, useDispatch } from "react-redux";
import {
  triggerInsertBrandVoice,
  triggerUpdateBrandVoice,
} from "../../../store/slices/brandVoice";

const BrandVoiceModal = ({ open, onClose, companyId, data }) => {
  const [isEdit, setEdit] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("all");
  const [voiceName, setVoiceName] = useState("");
  const [voiceDescription, setVoiceDescription] = useState("");
  const { locations } = useSelector(locationsSelector);
  const dispatch = useDispatch();

  const locationsList = useMemo(() => (_.uniqBy(_.cloneDeep(locations),'locationId')), [locations]);
  const brandVoiceData = useMemo(() => _.cloneDeep(data), [data]);

  useEffect(() => {
    if (brandVoiceData) {
      setEdit(true);
      setSelectedLocation(
        brandVoiceData?.locationId ? brandVoiceData?.locationId : "all"
      );
      setVoiceName(brandVoiceData?.name);
      setVoiceDescription(brandVoiceData?.description);
    }
  }, [brandVoiceData]);
  const handleSave = () => {
    if (isEdit) {
      dispatch(
        triggerUpdateBrandVoice(
          {
            CompanyId: companyId,
            LocationId: selectedLocation !== "all" ? selectedLocation : null,
            Name: voiceName,
            Description: voiceDescription,
            BrandVoiceId: brandVoiceData?.brandVoiceId,
          },
          companyId
        )
      );
    } else {
      dispatch(
        triggerInsertBrandVoice(
          {
            CompanyId: companyId,
            LocationId: selectedLocation !== "all" ? selectedLocation : null,
            Name: voiceName,
            Description: voiceDescription,
          },
          companyId
        )
      );
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? "Edit" : "Add"} Voice</DialogTitle>
      <Divider />
      <DialogContent>
        <FormControl size="small" fullWidth variant="outlined" margin="normal">
          <InputLabel>Select a Location</InputLabel>
          <Select
            size="small"
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
            label="Select a Location"
          >
            <MenuItem value={"all"}>All</MenuItem>
            {locationsList
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((location) => (
                <MenuItem key={location.locationId} value={location.locationId}>
                  {location.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <TextField
          size="small"
          fullWidth
          label="Voice Name"
          variant="outlined"
          margin="normal"
          value={voiceName ?? ""}
          onChange={(e) => setVoiceName(e.target.value)}
        />
        <TextField
          size="small"
          fullWidth
          multiline
          rows={4}
          label="Voice Description"
          variant="outlined"
          margin="normal"
          value={voiceDescription ?? ""}
          onChange={(e) => setVoiceDescription(e.target.value)}
        />
      </DialogContent>
      <Divider />
      <DialogActions
        sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
      >
        <Button
          onClick={handleSave}
          variant="contained"
          size="small"
          color="primary"
          disabled={voiceDescription.trim() === ""}
        >
          Save
        </Button>
        <Button
          onClick={onClose}
          size="small"
          variant="outlined"
          color="error"
          sx={{ ml: 2 }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrandVoiceModal;
